import styles from '../styles.scss';

const PricingPlansInfo = () => (
  <div className={ styles.pricingPanelContainer }>
    Market data plans are subject to a $3,000 minimum annual spend per organization
    (~2 premium licenses or 1 professional license). Speak to a member of our sales team for more information.
  </div>
);

export default PricingPlansInfo;
